import styled from 'styled-components';

export const Wrapper = styled.div`
  font-family: Montserrat;
  background: #2253f5;
  width: 100%;

  .pagseguro {
    display: flex;
    justify-content: center;
    align-items: center;

    font-family: Source Sans Pro;
    font-size: 0.85rem;
    color: #fff;

    padding: 2.5rem 0;
    margin-top: -6rem;
  }

  .pagseguro_en {
    display: flex;
    justify-content: center;
    align-items: center;

    font-family: Source Sans Pro;
    font-size: 0.85rem;
    color: #fff;

    padding: 1rem 0;
    margin-top: -2rem;
  }

  .footer {
    max-width: 1300px;
    margin: 0 auto;
    padding: 30px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nav-links {
      h3 {
        font-size: 1rem;
        color: #fcff7c;
        font-weight: 600;
        margin-bottom: 0.5rem;
      }
        
      ul {
        padding: 0;
        display: flex;
        flex-direction: column;
        min-height: 187px;
        list-style: none;
        cursor: pointer;
        margin: 0;

        li {
          a {
            text-decoration: none;
            font-family: Montserrat;
            font-size: 1rem;
            line-height: 2rem;
            font-weight: 600;
            color: #fff;
            transition: color 0.2s ease;

            &:hover {
              color: #fcff7c;
            }
          }
        }
      }
    }

    .nav-links_en {
      ul {
        display: flex;
        flex-direction: row;
        gap: 8rem;
        list-style: none;

        h3 {
          font-size: 1rem;
          color: #fcff7c;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        a {
          text-decoration: none;
        }

        li {
          font-family: Montserrat;
          font-size: 1rem;
          line-height: 2rem;
          font-weight: 600;
          color: #fff;
          transition: color 0.2s ease;

          &:hover {
            color: #fcff7c;
          }
        }
      }
    }

    .cloudez {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      margin-top: 13px;

      span {
        margin-top: 4px;
        font-family: Source Sans Pro;
        font-style: normal;
        font-weight: normal;
        font-size: 1.125rem;
        line-height: 160%;
        color: #ffffff;
      }

      @media (max-width: 768px) {
        span {
          text-align: center;
          margin-top: 0.95rem;
          font-size: 0.75rem;
        }
      }
    }

    .icons {
      display: flex;
      margin-top: 1.25rem;
      margin-left: -1rem;

      a {
        margin-left: 15px;
      }
    }

    .icons-en {
      display: flex;
      margin-top: -0.5rem;
      margin-left: -1rem;

      a {
        margin-left: 15px;
      }
    }

    .stamps {
      display: flex;
      flex-direction: column;
      margin-right: -1.2rem;
    }
  }

  @media (max-width: 768px) {
    .pagseguro {
      max-width: 117px;
      margin: -1.5rem auto auto auto;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      line-height: 19.2px;
    }

    .pagseguro_en {
      max-width: 117px;
      padding: 2rem 0;
      margin: -1.5rem auto auto auto;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      line-height: 19.2px;
    }

    .nav-links,
    .nav-links_en {
      display: none;
    }
    .footer {
      flex-direction: column;
      .icons {
        margin-top: 1.25rem;
        margin-left: 0.2rem;
      }

      .icons-en {
        margin-top: 20px;
      }
      span {
        margin-left: 0.8rem;
      }
    }
  }
`;
